export default __webpack_public_path__ + "static/media/Foundations_8x1.256.4f96b0f8.png";